import { useTooltipEngine } from './TooltipContext';
import { TooltipFloating } from './TooltipFloating';
import { TooltipTippy } from './TooltipTippy';

export { TooltipEngineProvider } from '@/components/base/Tooltip/TooltipContext';
export type { TooltipProps } from '@/components/base/Tooltip/types';

const Tooltip = (props: React.ComponentProps<typeof TooltipTippy>) => {
    const engine = useTooltipEngine();

    if (engine === 'floating-ui') {
        return <TooltipFloating {...props} />;
    }

    return <TooltipTippy {...props} />;
};

export default Tooltip;
